/* eslint-disable */
// added "types": ["lodash"] to the TSconfig, to get those types
// If somebody has a better idea, I welcome you to change this
// Help would be appreciated ))
// Lodash size changed from 645kb -> 220kb
export const omitBy: _.LoDashStatic['omitBy'] = require('lodash/omitBy');
export const isEmpty: _.LoDashStatic['isEmpty'] = require('lodash/isEmpty');
export const filter: _.LoDashStatic['filter'] = require('lodash/filter');
export const uniqueId: _.LoDashStatic['uniqueId'] = require('lodash/uniqueId');
export const reverse: _.LoDashStatic['reverse'] = require('lodash/reverse');
export const orderBy: _.LoDashStatic['orderBy'] = require('lodash/orderBy');
export const find: _.LoDashStatic['find'] = require('lodash/find');
export const once: _.LoDashStatic['once'] = require('lodash/once');
export const get: _.LoDashStatic['get'] = require('lodash/get');
export const includes: _.LoDashStatic['includes'] = require('lodash/includes');
export const omit: _.LoDashStatic['omit'] = require('lodash/omit');
export const noop: _.LoDashStatic['noop'] = require('lodash/noop');
export const concat: _.LoDashStatic['concat'] = require('lodash/concat');
export const chunk: _.LoDashStatic['chunk'] = require('lodash/chunk');
export const range: _.LoDashStatic['range'] = require('lodash/range');
export const uniqBy: _.LoDashStatic['uniqBy'] = require('lodash/uniqBy');
export const debounce: _.LoDashStatic['debounce'] = require('lodash/debounce');
export const throttle: _.LoDashStatic['throttle'] = require('lodash/throttle');
export const reduce: _.LoDashStatic['reduce'] = require('lodash/reduce');
export const uniq: _.LoDashStatic['uniq'] = require('lodash/uniq');
export const defaults: _.LoDashStatic['defaults'] = require('lodash/defaults');
export const truncate: _.LoDashStatic['truncate'] = require('lodash/truncate');
export const groupBy: _.LoDashStatic['groupBy'] = require('lodash/groupBy');
export const every: _.LoDashStatic['every'] = require('lodash/every');
export const template: _.LoDashStatic['template'] = require('lodash/template');
export const isEqual: _.LoDashStatic['isEqual'] = require('lodash/isEqual');
export const map: _.LoDashStatic['map'] = require('lodash/map');
export const sample: _.LoDashStatic['sample'] = require('lodash/sample');
export const kebabCase: _.LoDashStatic['kebabCase'] = require('lodash/kebabCase');
export const capitalize: _.LoDashStatic['capitalize'] = require('lodash/capitalize');
export const indexOf: _.LoDashStatic['indexOf'] = require('lodash/indexOf');
export const delay: _.LoDashStatic['delay'] = require('lodash/delay');
export const toNumber: _.LoDashStatic['toNumber'] = require('lodash/toNumber');
